const B2B_CONTENT_MAX_WIDTH = "1280px";
export {
  B2B_CONTENT_MAX_WIDTH
};
